<template>
  <component :is="component" :class="classObj" :options="options"></component>
</template>

<script>
export default {
  name: 'Card',
  props: [ 'options', 'component' ],
  data () {
    return {
      classObj: {
        'card': true,
        'card--regular': this.options.type === 'regular',
        'card--horizontal': this.options.type === 'horizontal',
        'card--vertical': this.options.type === 'vertical',
      }
    }
  }
}
</script>